import { render, staticRenderFns } from "./ModalCadastroObjetivo.vue?vue&type=template&id=9d3f7fd4"
import script from "./ModalCadastroObjetivo.vue?vue&type=script&lang=js"
export * from "./ModalCadastroObjetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports